import { Component } from '@angular/core';
import { CanViewAuditTrailComponent } from './can-view-audit-trail.component';
import { RouterLink } from '@angular/router';
import { CanViewAuditTrailMonthlyStatementsDistributionComponent } from './monthly-statements-distribution/can-view-audit-trail-monthly-statements-distribution.component';
import { CanViewAuditTrailUserSigninsComponent } from './user-signins/can-view-audit-trail-user-signins.component';
import { CanViewAuditTrailIbPrivateOpportunitiesDistributionComponent } from './ib-private-opportunities-distribution/can-view-audit-trail-ib-private-opportunities-distribution.component';
import { CanViewAuditTrailMappingsComponent } from './mappings/can-view-audit-trail-mappings.component';
import { CanViewAuditTrailTransactionNotesDistributionComponent } from './transaction-notes-distribution/can-view-audit-trail-transaction-notes-distribution.component';
import { CanViewAuditTrailUserActionsComponent } from './user-actions/can-view-audit-trail-user-actions.component';

@Component({
  selector: 'eaa-audit-trail-nav-menu',
  imports: [
    CanViewAuditTrailComponent,
    CanViewAuditTrailIbPrivateOpportunitiesDistributionComponent,
    CanViewAuditTrailMappingsComponent,
    CanViewAuditTrailMonthlyStatementsDistributionComponent,
    CanViewAuditTrailTransactionNotesDistributionComponent,
    CanViewAuditTrailUserActionsComponent,
    CanViewAuditTrailUserSigninsComponent,
    RouterLink
  ],
  template: `
    <eaa-can-view-audit-trail>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <span class="bi bi-journal" aria-hidden="true"></span> AUDIT TRAIL
        </a>
        <ul class="dropdown-menu">
          <eaa-can-view-audit-trail-ib-private-opportunities-distribution>
            <li>
              <a class="dropdown-item" [routerLink]="['/audit-trail', 'ib-private-opportunities-distribution']"
                >IB PRIVATE OPPORTUNITIES DISTRIBUTION</a
              >
            </li>
          </eaa-can-view-audit-trail-ib-private-opportunities-distribution>
          <eaa-can-view-audit-trail-monthly-statements-distribution>
            <li>
              <a class="dropdown-item" [routerLink]="['/audit-trail', 'monthly-statements-distribution']"
                >MONTHLY STATEMENTS DISTRIBUTION</a
              >
            </li>
          </eaa-can-view-audit-trail-monthly-statements-distribution>
          <eaa-can-view-audit-trail-transaction-notes-distribution>
            <li>
              <a class="dropdown-item" [routerLink]="['/audit-trail', 'transaction-notes-distribution']"
                >TRANSACTION NOTES DISTRIBUTION</a
              >
            </li>
            <li>
              <a class="dropdown-item" [routerLink]="['/audit-trail', 'transaction-notes-reconciliation']"
                >TRANSACTION NOTES RECONCILIATION</a
              >
            </li>
          </eaa-can-view-audit-trail-transaction-notes-distribution>
          <eaa-can-view-audit-trail-mappings>
            <li>
              <a class="dropdown-item" [routerLink]="['/audit-trail', 'mappings']">MAPPINGS</a>
            </li>
          </eaa-can-view-audit-trail-mappings>
          <eaa-can-view-audit-trail-user-actions>
            <li>
              <a class="dropdown-item" [routerLink]="['/audit-trail', 'user-actions']">USER ACTIONS</a>
            </li>
          </eaa-can-view-audit-trail-user-actions>
          <eaa-can-view-audit-trail-user-signins>
            <li>
              <a class="dropdown-item" [routerLink]="['/audit-trail', 'user-signins']">USER SIGNINS</a>
            </li>
          </eaa-can-view-audit-trail-user-signins>
        </ul>
      </li>
    </eaa-can-view-audit-trail>
  `
})
export class AuditTrailNavMenuComponent {}
